import React from 'react';
import styles from '../css/comuns/PlanoControle.module.css';
import { config } from '../../data';
import { Link } from 'react-router-dom';

const PlanoControle = () => {
    return (
        <>
            <div className={styles['container7']}>
                <img src={config.images.planoControle.background5g} alt="5G" className={styles['main-image7']} />
                <div className="container-fluid">
                    <div className={`row ${styles['right-section7']}`}>
                        <div className={`col-md-6 ${styles['left-section7']}`}>
                            <h1>{config.texts.planoControle.titulo}</h1>
                            <h2>{config.texts.planoControle.subtitulo}</h2>
                            <div className={styles['subtext7']}>
                                <h3>{config.texts.planoControle.beneficios.ligacoes}</h3>
                                <h3>{config.texts.planoControle.beneficios.ilimitadas}</h3>
                                <h3><span className={styles['span27']}>{config.texts.planoControle.beneficios.mais}</span> {config.texts.planoControle.beneficios.internet}</h3>
                                <h3>{config.texts.planoControle.beneficios.movel}</h3>
                                <h3>{config.texts.planoControle.beneficios.apartir}</h3>
                            </div>
                            <div className={styles['price-container7']}>
                                <div className={styles['price-symbol7']}>R$</div>
                                <div className={styles['price-big7']}>{config.texts.planoControle.preco.split(',')[0]}</div>
                                <div className={styles['price-small7']}>,{config.texts.planoControle.preco.split(',')[1]}</div>
                            </div>
                            <button className={styles['cta-button7']}>
                                <Link to={config.links.routes.telefonia} className={styles['cta-link']}>{config.texts.planoControle.botao}</Link>
                            </button>
                            <div className="col-md-6 d-flex justify-content-end">
                                <div className={styles['icons7']}>
                                    <div className={styles['icon-smartphone7']}>
                                        <img src={config.images.planoControle.smartphone} alt="Smartphone" className="img-fluid" />
                                        <div className={styles['icon-sim7']}>
                                            <img src={config.images.planoControle.chip} alt="Chip" className="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles['info-section7']}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <img src={config.images.planoControle.figurafeminina} alt="Person with phone" className={`${styles['person-image7']} img-fluid`} />
                        </div>
                        <div className={`col-md-6 ${styles['info-text7']}`}>
                            <h2>{config.texts.planoControle.secaoInfo.titulo}</h2>
                            <p className={styles['main-paragraph7']}>
                                {config.texts.planoControle.secaoInfo.descricao}
                            </p>
                            <p className={styles['footnote7']}>
                                {config.texts.planoControle.secaoInfo.rodape}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PlanoControle;